<template lang='pug'>
  
	div
		ul.list-group.listagem-registros(
				@mouseleave="onResultadosMouseLeave()",
				v-if="registros && registros.length")

			li.list-group-item(v-for="r in registros", @mouseenter="onRegistroMouseEnter(r)") 

				span.listagem-registros-titulo(:title="r.titulo") {{ r.titulo || r.nomeCamada }}
				small.listagem-registros-subtitulo {{ r.nomeCamada }}
				
				i.action-icon.fa.fa-chevron-right.pull-right(@click="exibirRegistro(r)")

		empty-result.full-height(message="Nenhum resultado encontrado.", v-if="registros && registros.length === 0")

</template>

<script>

import EmptyResult from '@/components/utils/EmptyResult';
import markerStyles from '@/utils/markerStyles';

const MARKER_CODE = 'InformacoesPontoComponent';

export default {
	name: 'ListagemRegistrosCamada',

	components: { EmptyResult },

	props: {
		registros: Array,
		showMarkers: Boolean
	},

	methods: {

		exibirRegistro (registro) {

			this.$emit('exibirRegistro', { registro: registro });
		},

		onRegistroMouseEnter (reg) {

			if (this.showMarkers && reg.centroid) {

				this.$bus.$emit('mapa.addCoordinatePoint', {
					markerCode: MARKER_CODE,
					lat: reg.centroid.coordinates[1],
					lng: reg.centroid.coordinates[0],
					markerStyle: markerStyles.registroCamada,
					center: false
				});
			}
		},

		onResultadosMouseLeave () {

			if (this.showMarkers && this.registros && this.registros.length) {
				this.removerMarcador(MARKER_CODE);
			}
		},

		removerMarcador () {
			this.$bus.$emit('mapa.removeCoordinatePoint', MARKER_CODE);
		},

		limpar () {
			this.removerMarcador();
		}
	}
};

</script>



// WEBPACK FOOTER //
// ListagemRegistrosCamada.vue?22396cab